import React, { useEffect, useState } from "react";
import CustomInput from "../component/CustomInput";
import CopyrightComponent from "../component/CopyrightComponent";
import { useNavigate } from "react-router-dom";
import ApiService from "../utils/ApiService";
import { ConfigProvider, notification, Spin, Image, Input } from "antd";
import { constants } from "../constant/constants";

function NewPassword() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [apiCalling, setApiCalling] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [payload, setPayload] = useState({
    countryCode: "880",
    phone: localStorage.getItem("phone"),
    password: "",
    confirmPassword: "",
  });
  const [formPosition, setFormPosition] = useState({
    marginTop: "50px",
  });

  const openNotification = (
    type,
    message,
    description,
    placement = "topRight"
  ) => {
    api[type]({
      message,
      description,
      placement,
    });
  };

  useEffect(() => {
    calculateCenter();
  }, []);

  useEffect(() => {
    const storeOtpData = localStorage.getItem("otpVerifyObj") || "{}";
    const otp = JSON.parse(storeOtpData);

    if (otp && otp.phone) {
      setPayload({
        ...payload,
        phone: otp.phone
      })
    }
  }, [])

  const calculateCenter = () => {
    const loginFormHeight = document.getElementById("login-form").offsetHeight;
    const mainFormHeight = document.getElementById("main-form").offsetHeight;
    let freeHeight = (mainFormHeight - loginFormHeight) / 3;
    setFormPosition({
      marginTop: `${freeHeight}px`,
    });
  };

  const goBack = () => {
    navigate("/");
  };

  const setNewPassword = () => {
    if (! payload.phone) {
      setApiCalling(true);
      return setTimeout(() => { navigate("/"); }, 1000);
    }
    if (payload.password == "" || payload.confirmPassword == "") {
      setError("Both password required");
      return;
    }
    if (payload.password != payload.confirmPassword) {
      setError("Password not matched");
      return;
    }
    setApiCalling(true);
    ApiService.NEW_PASSWORD_SET(payload).then((res) => {
      setApiCalling(false);
      if (res.code === 200) {
        localStorage.clear("phone");
        openNotification(
          constants.NOTIFICATION.SUCCESS,
          "Success",
          "Password change success"
        );
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        setError(res.message);
      }
    });
  };

  const goToLogin = () => {
    navigate("/");
  };
  const updatePassword = (val) => {
    setPayload({
      ...payload,
      password: val,
    });
  };
  const updateConfirmPassword = (val) => {
    setPayload({
      ...payload,
      confirmPassword: val,
    });
  };

  return (
    <div
      id="main-form"
      style={{ height: "100vh" }}
      className="flex flex-col items-center p-[50px] bg-yellow"
    >
      {contextHolder}
      <div
        id="login-form"
        style={formPosition}
        className="flex w-[360px] flex-col lg:w-[400px] bg-white justify-center border-[1px] border-gray-300 rounded-[5px] p-[20px]"
      >
        <div
          className="flex mb-[10px] items-center justify-center gap-x-[20px]"
          onClick={goToLogin}
        >
          <Image
            src={`/images/icons/TableTap_icon.svg`}
            preview={false}
            alt="tabletap"
            className="w-[96px] h-[96px]"
          />
          <div className="text-2xl font-bold text-red-600 font-ubold pb-[10px] content-center">
            <Image
              src={`/images/Scan_Order_Savor.png`}
              preview={false}
              alt="scan_order_savor"
              className="pt-[10px]"
            />
          </div>
        </div>
        {error ? (
          <div className="text-red-700 ml-[20px] py-[8px] flex flex-col font-regular cursor-pointer">
            {error}
          </div>
        ) : (
          ""
        )}
        <div className="w-full flex flex-col px-[16px] mb-[12px]">
          <div class="text-sm flex flex-row font-uregular">
            <div>New Password</div>
            <div class="font-ubold text-red-700 ml-[2px]">*</div>
          </div>
          
          <Input.Password
            placeholder="Write your new password"
            onChange={e => updatePassword(e.target.value)}
            onPressEnter={setNewPassword}
            required={true}
            value={payload.password}
            className="h-[34px] font-uregular"
          />
        </div>
        <div className="w-full flex flex-col px-[16px] mb-[12px]">
          <div class="text-sm flex flex-row font-uregular">
            <div>Confirm New Password</div>
            <div class="font-ubold text-red-700 ml-[2px]">*</div>
          </div>
          
          <Input.Password
            placeholder="Confirm your new password"
            onChange={e => updateConfirmPassword(e.target.value)}
            required={true}
            onPressEnter={setNewPassword}
            value={payload.confirmPassword}
            className="h-[34px] font-uregular"
          />
        </div>
        <div className="flex flex-row px-[16px] mt-[8px]">
          {apiCalling ? (
            <div className="w-[90px] text-center">
              <ConfigProvider
                theme={{
                  components: {
                    Spin: {
                      colorPrimary: "#EE3169",
                    },
                  },
                }}
              >
                <Spin
                  size="medium"
                  className="w-[66px]text-center items-center"
                />
              </ConfigProvider>
            </div>
          ) : (
            <div
              className="bg-yellow text-black px-[12px] py-[8px] rounded-[5px] font-ubold cursor-pointer"
              onClick={setNewPassword}
            >
              Change
            </div>
          )}
          <div
            className="text-black px-[12px] py-[8px] font-ulight underline cursor-pointer"
            onClick={goBack}
          >
            Back to Login
          </div>
        </div>
      </div>
      <CopyrightComponent />
    </div>
  );
}

export default NewPassword;
